import React, { useState } from "react";
import * as XLSX from "xlsx";
import {
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { db } from "../firebaseConfig"; // Ajusta la ruta si es necesario
import { collection, doc, setDoc } from "firebase/firestore";

const BulkUpload = () => {
  const [excelData, setExcelData] = useState([]);

  // Función para manejar la carga del archivo
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        setExcelData(jsonData); // Guardar los datos en el estado
      };
      reader.readAsArrayBuffer(file);
    }
  };

  // Función para convertir cadenas de texto "true"/"false" a booleanos
  const toBoolean = (value) => value.toLowerCase() === "true";

  // Función para guardar los datos en Firestore con ID personalizado
  const saveDataToFirestore = async (data) => {
    const collectionRef = collection(db, "bebidas");

    try {
      for (const item of data) {
        // Verifica que todos los campos estén presentes y asigna valores predeterminados si están vacíos
        const formattedItem = {
          id: item.id || "N/A",
          nombre: item.nombre || "N/A",
          precioCombinado: item.precioCombinado || 0,
          precioCopaHielo: item.precioCopaHielo || 0,
          precioChupito: item.precioChupito || 0,
          descripcion: item.descripcion || "N/A",
          categoria: item.categoria || "N/A",
          visible: toBoolean(item.visible), // Conversión de "true"/"false" a booleano
          destacado: toBoolean(item.destacado), // Conversión de "true"/"false" a booleano
          imagenUrl: item.imagenUrl || "N/A",
        };

        // Genera el ID del documento basado en la categoría y el nombre
        const docId =
          `${formattedItem.categoria}_${formattedItem.nombre}`.replace(
            /\s+/g,
            "_"
          );

        // Guarda el documento con el ID personalizado en Firestore
        await setDoc(doc(collectionRef, docId), formattedItem);
      }
      alert("Datos guardados exitosamente en Firebase");
    } catch (error) {
      console.error("Error al guardar datos en Firestore:", error);
      alert("Hubo un error al guardar los datos.");
    }
  };

  // Función para enviar los datos cargados
  const handleDataSubmit = () => {
    const formattedData = excelData.slice(1).map((row) => ({
      id: row[1],
      nombre: row[2],
      precioCombinado: row[3],
      precioCopaHielo: row[4],
      precioChupito: row[5],
      descripcion: row[6],
      categoria: row[7],
      visible: row[8], // Se asumirá que ya es "true" o "false" en texto
      destacado: row[9], // Se asumirá que ya es "true" o "false" en texto
      imagenUrl: row[10],
    }));

    saveDataToFirestore(formattedData);
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Typography variant="h6" color="primary">
        Cargar Datos desde Excel
      </Typography>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        style={{ margin: "20px 0" }}
      />
      {excelData.length > 0 && (
        <>
          <TableContainer
            component={Paper}
            style={{ maxHeight: "90vh", overflowY: "auto", margin: "20px 0" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Orden</TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Precio Combinado</TableCell>
                  <TableCell>Precio Copa Hielo</TableCell>
                  <TableCell>Precio Chupito</TableCell>
                  <TableCell>Descripción</TableCell>
                  <TableCell>Categoría</TableCell>
                  <TableCell>Visible</TableCell>
                  <TableCell>Destacado</TableCell>
                  <TableCell>Imagen URL</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {excelData.slice(1).map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row[0]}</TableCell>
                    <TableCell>{row[1]}</TableCell>
                    <TableCell>{row[2]}</TableCell>
                    <TableCell>{row[3]}</TableCell>
                    <TableCell>{row[4]}</TableCell>
                    <TableCell>{row[5]}</TableCell>
                    <TableCell>{row[6]}</TableCell>
                    <TableCell>{row[7]}</TableCell>
                    <TableCell>{row[8]}</TableCell>
                    <TableCell>{row[9]}</TableCell>
                    <TableCell>{row[10]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDataSubmit}
          >
            Subir Datos
          </Button>
        </>
      )}
    </div>
  );
};

export default BulkUpload;
